import api from '../services/api';

export async function downloadQuotePdf(quoteId) {
  const response = await api.get(`/customers/quotes/${quoteId}/download_pdf/`, {
    responseType: 'blob',
  });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const short = String(quoteId).replace(/-/g, '').slice(0, 8);
  link.download = `quote-${short}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
